import { Injectable } from '@angular/core';
import { Headers, RequestOptions } from '@angular/http';

@Injectable()
export class Utils {
	today() { 
		var currentdate = new Date(); 
		var datetime =    currentdate.getDate() + "/"
		                + (currentdate.getMonth()+1)  + "/" 
		                + currentdate.getFullYear() + " @ "  
		                + currentdate.getHours() + ":"  
		                + currentdate.getMinutes() + ":" 
		                + currentdate.getSeconds();
		return datetime;		          
	}

	todayDateTime() { 
		var currentdate = new Date(); 
		var datetime =    currentdate.getFullYear() + "-"
		                + (currentdate.getMonth()+1)  + "-" 
		                + currentdate.getDate() + "T"  
		                + currentdate.getHours() + ":"  
		                + currentdate.getMinutes() + ":" 
		                + currentdate.getSeconds();
		return datetime;		          
	}

	getMilliseconds(dateStr){
		return new Date(dateStr).getTime();
	}

	formatTime(dateStr){
		return (new Date(dateStr)).toLocaleTimeString();
	}	

	daysLeftText(date){
		var date1 = new Date(date);
		var today = new Date();

		var timeDiff = Math.abs(today.getTime() - date1.getTime());
		var daysLeft = Math.ceil(timeDiff / (1000 * 3600 * 24)); 	

		return 	(daysLeft==1) ? daysLeft + " day left" : daysLeft + " days left";
	}

	pushItemToList(list, item){
		list.push(item);
	}

	removeItemFromList(list, attributeName, item){
		for (var i = list.length - 1; i >= 0; i--) {
			if(list[i][attributeName] == item[attributeName]){
				list.splice(i, 1);
				break;
			}
		}
	}	

	concatenateList(list, attributeName, delimiter){
		var returnVal="";

		for (var i = 0; i < list.length; ++i) {
			returnVal += list[i][attributeName] + 
						 ((i == list.length-1) ? "" : delimiter );
		}

		return returnVal;
	}	

	returnItemFromList(list, attributeName, compareValue){
		let returnVal: any ={};

		for (var i = 0; i < list.length; ++i) {
			if(list[i][attributeName] == compareValue){
				returnVal = list[i];
				break;
			}
		}		

		return returnVal;
	}
}




// WEBPACK FOOTER //
// ./src/helpers/utils.ts